import ListingCard from "@/components/ListingCard";
import LoadingSpinner from "@/components/LoadingSpinner";
import PageHeading from "@/components/PageHeading";
import PageNumbers from "@/components/PageNumbers";
import { pushQueryParam, removeRootPage } from "@/lib/utils";
import {
	NewsIndex as NewsIndexType,
	NewsPage,
	useGetNewsListingQuery,
} from "graphql/generated-types";
import { useRouter } from "next/router";
import React from "react";
import { IndexContainer, ListingContainer, PillContainer } from "./IndexContainer";

const NewsIndex = ({ data }: { data: NewsIndexType }) => {
	const router = useRouter();
	const perPage = 12;
	const { data: newsList, loading } = useGetNewsListingQuery({
		variables: {
			page: router.query.page ? parseInt(router.query.page as string) : 1,
			perPage: perPage,
			tags: router.query.tag ? (router.query.tag as string) : undefined,
		},
	});
	let items: NewsPage[] = loading ? [] : (newsList?.newsPages?.items as NewsPage[]);
	const total = newsList?.newsPages?.pagination?.total;
	const pages = Math.ceil(total / perPage);
	const currentPage = router.query.page ? parseInt(router.query.page as string) : 1;

	const tagQuery = router.query.tag;

	const handlePageChange = (page: number) => {
		pushQueryParam(`?page=${page}`, router);
	};

	const handleTagChange = (tag?: string) => {
		pushQueryParam(tag ? `?tag=${tag}` : undefined, router);
	};

	const handleNextPage = () => {
		const nextPage = router.query.page ? parseInt(router.query.page as string) + 1 : 2;
		handlePageChange(nextPage);
	};

	return (
		<IndexContainer>
			<PageHeading title={data.title} />
			<PillContainer>
				<button className={tagQuery ? "tag-pill" : "tag-pill-reversed"} onClick={() => handleTagChange()}>
					View all
				</button>
				{data.tags?.map((tag, i) => (
					<button
						key={i}
						className={tagQuery === tag?.slug ? "tag-pill-reversed" : "tag-pill"}
						onClick={() => handleTagChange(tag?.slug!)}
					>
						{tag?.name}
					</button>
				))}
			</PillContainer>
			<ListingContainer>
				{loading && <LoadingSpinner />}
				{items?.map((item) => {
					return (
						<ListingCard
							key={item?.id}
							imageSrc={item?.heroImage?.rendition?.url!}
							imageAlt={item?.heroImage?.rendition?.image?.title!}
							title={item?.title}
							tags={item.tags?.map((tag) => ({ name: tag?.name!, slug: data.slug + "?tag=" + tag?.slug! }))}
							linkHref={removeRootPage(item.urlPath)}
							linkText="View article"
						/>
					);
				})}
			</ListingContainer>
			<PageNumbers
				pages={pages}
				currentPage={currentPage}
				handlePageChange={handlePageChange}
				handleNextPage={handleNextPage}
			/>
		</IndexContainer>
	);
};

export default NewsIndex;
